import { COLORS } from '@/constants/colors'

export const checkboxColors = {
    primary: {
        default: COLORS.primary400,
        hover: COLORS.primary600,
        notChecked: COLORS.grayDark,
        checked: COLORS.primary50,
        disabled: COLORS.primary600,
    },

    red: {
        default: COLORS.errorLight,
        hover: COLORS.errorLight,
        notChecked: COLORS.grayDark,
        checked: COLORS.errorLightest,
        disabled: COLORS.errorLight,
    },
}
